// For future references see: https://github.com/bradvin/social-share-urls
import { formatAsBRLWithSignal } from '../number';

import OFFER from 'constants/offer';
import SOCIAL_MEDIA from 'constants/socialMedia';

export const formatLinkWithUtms = ({
  redirectUrl,
  utmMedium,
  utmSource = 'promobit',
  utmCampaign,
}) =>
  `${redirectUrl}?utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${encodeURIComponent(
    utmCampaign
  )}`;

const getEnrichShareUrl = (initialUrl) => {
  const url = new URL(initialUrl ?? window.location);

  return encodeURIComponent(
    `${url.host}${url.pathname}?${SOCIAL_MEDIA.SHARE_UTMS}`
  );
};

export const formatOfferShareText = ({
  offerTitle,
  offerPrice,
  offerPriceType,
  socialMedia,
}) => {
  let formattedPrice = '';

  switch (offerPriceType) {
    case OFFER.PRICE_TYPES.FREE:
      formattedPrice = `de graça`;
      break;
    case OFFER.PRICE_TYPES.STARTING_AT:
      formattedPrice = `a partir de ${formatAsBRLWithSignal(offerPrice)}`;
      break;
    case OFFER.PRICE_TYPES.COUPON:
      formattedPrice = `Cupom`;
      break;
    default:
      formattedPrice = `por ${formatAsBRLWithSignal(offerPrice)}`;
      break;
  }

  const shareText = `${offerTitle} - ${formattedPrice} no Promobit!`;

  return socialMedia === SOCIAL_MEDIA.EMAIL.TITLE
    ? `${encodeURIComponent(
        'Encontrei essa oferta e acho que você vai gostar!'
      )}%0a%0a${shareText}`
    : shareText;
};

const getEmailShareUrl = ({ socialMediaURL, enrichUrl, shareText, subject }) =>
  `${socialMediaURL}?subject=${subject}&body=${shareText}%0A%0A${enrichUrl}`;

const getGenericShareUrl = ({ socialMediaURL, enrichUrl, shareText }) =>
  `${socialMediaURL}${enrichUrl}&text=${shareText}`;

const getWhatsappShareUrl = ({ shareText, enrichUrl }) => {
  const socialMediaURL = SOCIAL_MEDIA.WHATSAPP.SHARE_URL;

  return `${socialMediaURL}?text=${shareText}%20${enrichUrl}`;
};

const getSocialMediaShareUrl = ({
  socialMedia,
  shareText,
  enrichUrl,
  subject,
}) => {
  const socialMediaProps = Object.values(SOCIAL_MEDIA).find(
    (s) => s.TITLE === socialMedia
  );
  const socialMediaURL = socialMediaProps ? socialMediaProps.SHARE_URL : '';

  switch (socialMedia) {
    case SOCIAL_MEDIA.EMAIL.TITLE:
      return getEmailShareUrl({
        enrichUrl,
        shareText,
        socialMediaURL,
        subject,
      });
    case SOCIAL_MEDIA.WHATSAPP.TITLE:
      return getWhatsappShareUrl({
        enrichUrl,
        shareText,
      });
    default:
      return getGenericShareUrl({
        enrichUrl,
        shareText,
        socialMediaURL,
      });
  }
};

export const shareToWithText = (socialMedia, text) => {
  const shareText = encodeURIComponent(text);

  window.open(
    getSocialMediaShareUrl({
      enrichUrl: getEnrichShareUrl(),
      shareText,
      socialMedia,
    })
  );
};

export const shareTo = ({
  formatShareTextFn,
  url: initialUrl,
  socialMedia,
  subject = null,
  ...props
}) => {
  const enrichUrl = getEnrichShareUrl(initialUrl);

  const shareText = encodeURIComponent(
    formatShareTextFn({ socialMedia, ...props })
  );

  const enrichSocialMediaUrl = getSocialMediaShareUrl({
    socialMedia,
    shareText,
    enrichUrl,
    subject,
  });

  window.open(enrichSocialMediaUrl, '_blank');
};
